import React from "react";
import ToorakLogo from "../images/loanlistheader/logo1x.png";
import maintenanceVector from "../images/maintenanceVector.png"

export const UnderMaintanencePage = () => {
    return (
        <>
            <header
                style={{
                    backgroundImage: "linear-gradient(to right, #0fcbef, #1071ee 100%)",
                    padding: "1%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}
            >
                <div style={{ display: "flex", width: "100%" }}>
                    <img class="image" src={ToorakLogo} alt="logo" style={{ width: "15%", height: "auto" }} />
                </div>
            </header>
            <div style={{ textAlign: "center", marginTop: "3%", padding: "0% 15%" }}>
                <img src={maintenanceVector} alt="undermaintannence" style={{ width: "40%", height: "auto", maxWidth: "800px" }} />
                <h1 style={{ marginTop: "5%", fontWeight: "bold", fontSize: "4vh" }}>Website under maintenance</h1>
                <p style={{ fontSize: "3vh", marginTop: "2%" }}>Our platform is undergoing maintenance and is expected to be back in operation in a few hours. We appreciate your patience during this time.</p>
            </div>
        </>
    )
}